export function useTokens() {
  const csrfToken = document.getElementsByName("csrf-token")[0].content;

  const recaptchaSiteKey = document
    .querySelector('meta[name="recaptcha-site-key"]')
    .getAttribute("content");

  return { csrfToken, recaptchaSiteKey };
}
